import { PublicKey } from '@solana/web3.js'
import { parseUnits } from 'viem'

export function checkInvalidAmount(args: { value: string; balance: bigint; decimals: number }) {
    const { value, balance, decimals } = args
    try {
        const parsedAmount = parseTransferAmount({ value, decimals })
        if (parsedAmount <= 0n) {
            return {
                message: 'Amount must be greater than 0',
            }
        }

        if (parsedAmount > balance) {
            return {
                message: 'Insufficient balance',
            }
        }
    } catch (error) {
        return {
            message: 'Invalid amount',
        }
    }
}

export function parseTransferAmount(args: { value: string; decimals: number }) {
    const { value, decimals } = args
    try {
        return parseUnits(value, decimals)
    } catch (error) {
        return 0n
    }
}

export function toSolanaPublicKey(value: string) {
    try {
        return new PublicKey(value)
    } catch (error) {
        // noop
    }
}
